import styled from 'styled-components';
import tw from 'twin.macro';

export default styled.div`
  ${tw`overflow-y-auto z-10 fixed top-0 left-0 h-screen w-full grid place-items-center bg-neutral-dark bg-opacity-50`};
`;
